/**
 * Single source of truth for environment variables exposed to the terminal
 * client bundle.
 *
 * Each value MUST be a literal `process.env.<NAME>` read — Vite's `define`
 * step (see `apps/terminal/vite.config.ts`) statically replaces these
 * literals with the corresponding values at build time. Dynamic access
 * (`process.env[key]`) would NOT be replaced and would be `undefined` at
 * runtime in the browser.
 *
 * Adding a new client-side env var:
 *   1. Add `MY_KEY: process.env.MY_KEY` here.
 *   2. Read it via `envVars.MY_KEY` in app code.
 *   3. (Deploy) plumb the value through CI / `.env` as normal.
 *
 * The keys of this object are reflected back into `vite.config.ts` via
 * `Object.keys(envVars)`, so you never have to update the allow-list by
 * hand.
 */
export const envVars = {
  V2_API_BASE_URL: process.env.V2_API_BASE_URL,
  V2_VERSION: process.env.V2_VERSION,
  V2_ENV_LEVEL: process.env.V2_ENV_LEVEL,
  V2_FEATURE_FLAGS: process.env.V2_FEATURE_FLAGS,
  V2_TEAMS_APP: process.env.V2_TEAMS_APP,
  V2_RELEASE_DATE: process.env.V2_RELEASE_DATE,
  V2_RELEASE_NUMBER: process.env.V2_RELEASE_NUMBER,
  V2_HOST: process.env.V2_HOST,
  V2_CDN_PATH: process.env.V2_CDN_PATH,
  V2_IB_LINK_DISCLAIMER: process.env.V2_IB_LINK_DISCLAIMER,
  V2_ZENDESK_SUBDOMAIN: process.env.V2_ZENDESK_SUBDOMAIN,
  V2_STRIPE_PUBLIC_KEY: process.env.V2_STRIPE_PUBLIC_KEY,
  V2_AZURE_AD_TENANT_ID: process.env.V2_AZURE_AD_TENANT_ID,
  V2_AZURE_AD_CLIENT_ID: process.env.V2_AZURE_AD_CLIENT_ID,
  PUBLIC_POSTHOG_KEY: process.env.PUBLIC_POSTHOG_KEY,
  PUBLIC_POSTHOG_HOST: process.env.PUBLIC_POSTHOG_HOST,
  WEBSITE_DOMAIN: process.env.WEBSITE_DOMAIN,
  FARO_URL: process.env.FARO_URL,
  MS365_CLIENT_ID: process.env.MS365_CLIENT_ID,
} as const;

export type EnvVarName = keyof typeof envVars;
